module.exports = __webpack_public_path__ + "fonts/nunito-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Nunito/nunito-regular-webfont.woff2
// module id = 3446
// module chunks = 0